import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useTranslation }                                 from 'react-i18next';
import DV                                                 from 'ts-data-validator';

import { useRouter } from '../../../../common/hooks/useRouter';

import RenderButton              from '../../../components/buttons/base/RenderButton';
import ContactUs                 from '../../../components/buttons/ContactUs';
import ConsultationBlock         from '../../../components/consultationBlock';
import Preloader                 from '../../../components/containers/preloader';
import PageHeader                from '../../../components/pageHeader';
import { useCommon }             from '../../../providers/common';
import { useDealerRequestModal } from '../../../providers/dealerRequest';

import Notfound from '../../notfound/components/Notfound';

const StaticContent = function(props) {
  const {
          headerProps,
          label,
          renderSections,
        } = props;

  const {
          location: { pathname },
          match:    { params: { page: section } },
        } = useRouter();
  const {
          pages,
          loading,
          getPageData,
        } = useCommon();

  const {
          t,
          i18n: { language },
        }             = useTranslation();
  const { showModal } = useDealerRequestModal();

  const page = useMemo(() => {
    return pages.find((page) => page.urlKey === section);
  }, [pages, section]);

  const getInitialState = useCallback(() => {
    const page = pages.find((page) => `/${page.urlKey}` === pathname);

    if (!page.hasOwnProperty('content') && !page.hasOwnProperty('headImage') && !loading) {
      getPageData(pathname);
    }
  }, [getPageData, pages, pathname, loading]);

  useEffect(() => {
    getInitialState();
    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
  }, [pathname]);

  const renderPage = useCallback((page) => {
    const {
            content: Content,
            contactButtonName,
            inCatalogLabel,
            inCatalogLink,
            template,
          } = page;

    let content;
    try {
      content = JSON.parse(Content);
    } catch (e) {
    }

    if (!content) {
      return (
        <Notfound />
      );
    }

    return (
      <main className={page.template}>
        <article>
          {renderSections(content)}
        </article>
        <section className={'to-catalog'}>
          <div className={'container'}>
            <RenderButton
              type={'link'}
              uri={inCatalogLink || '/vhodnye-dveri'}
              label={inCatalogLabel || t('client_goToCatalog')}
              className={'fill'}
            />
            {(template === 'designers' || template === 'developers') ? (
              <button
                className={'btn fill'}
                onClick={showModal}
              >
                {contactButtonName || t('client_contactUs')}
              </button>
            ) : <ContactUs label={contactButtonName} />}
          </div>
        </section>
        <ConsultationBlock maxWidth={'1212px'} />
      </main>
    );
  }, [language, renderSections, showModal]);

  if (!page) {
    return (
      <Notfound />
    );
  }

  return (
    <>
      {DV.isNotEmptyString(label) && headerProps.transparent && (
        <PageHeader {...headerProps}>{label}</PageHeader>
      )}
      {page.hasOwnProperty('content') && page.hasOwnProperty('headImage') && (
        renderPage(page)
      )}
      {loading && (
        <Preloader />
      )}
    </>
  );
};

export default StaticContent;